import React, {Component} from 'react';
import {connect} from 'react-redux';
import SelectOpposingPlayers from 'components/molecules/select-opposing-players';
import PrioritizeCompletingLineupsAboveExp from 'components/molecules/prioritize-completing-lineups-above-exp';
import FilterBySalary from 'components/organisms/filter-by-salary';
import FilterByPoints from 'components/organisms/filter-by-points';
import LineupsQuantity from 'components/organisms/lineups-quantity';
import SelectSalaryCap from 'components/organisms/select-salary-cap';
import ProjectedOwnershipCap from 'components/organisms/projected-ownership-cap';
import ExposureMode from 'components/molecules/exposure-mode';
import UniquePlayersQuantity from 'components/molecules/unique-players-quantity';
import RangeOfOutcomes from 'components/organisms/range-of-outcomes/range-of-outcomes';
import OptimizeButton from 'components/molecules/optimize-button';
import UserPointsType from 'components/molecules/user-points-type';
import CompetitionStacking from 'components/organisms/competition-stacking';
import ShowPlayersExposureWhileOptimized from 'components/molecules/show-players-exposure-while-optimized';
import ProjectedOwnershipForce from 'components/organisms/projected-ownership-force';
import PlayerCombinationStacking from 'components/organisms/player-combination-stacking';
import OptimizeOpener from 'components/molecules/optimize-opener';
import Const from 'constants';
import PlayerGroupingsSwitch from 'components/molecules/player-groupings-switch';

class PlayersDashboardComponent extends Component {
    render() {
        const {sportConfig, playersFilter} = this.props;

        return (
            <div>
                <div className="filters-table">
                    <OptimizeOpener />
                    <div className="filters-top">
                        <div className="filters-top-holder">
                            <FilterBySalary
                                key={`sr-${playersFilter.playersType}`}
                                useDragging={true}
                                step={1}
                                roundValue={1}
                                mode={playersFilter.playersType}
                            />
                            <FilterByPoints
                                key={`pr-${playersFilter.playersType}`}
                                useDragging={true}
                                mode={playersFilter.playersType}
                            />
                            <SelectSalaryCap useDragging={true} />
                            <ProjectedOwnershipCap useDragging={true} />
                            <LineupsQuantity useDragging={true} />
                        </div>
                        <div className="filters-cell select-cell">
                            <ExposureMode />
                            <UserPointsType
                                options={{
                                    adminPoints: 'Projection',
                                    fptsWin: 'Fpts/Win Projection',
                                }}
                                tooltip={
                                    'Select from standard "Projections" or projections based on the assumption that the players on each of the teams win their games.'
                                }
                            />
                            <UniquePlayersQuantity />
                        </div>
                    </div>
                    <div className="filters-bottom">
                        <div className="filters-cell">
                            <ProjectedOwnershipForce />
                        </div>
                        <div className="filters-cell">
                            <PrioritizeCompletingLineupsAboveExp />
                        </div>
                        <div className="filters-cell">
                            <RangeOfOutcomes useDragging={true} config={{sport: 'mma'}} />
                        </div>
                        <div className="filters-cell">
                            <ShowPlayersExposureWhileOptimized />
                        </div>
                    </div>
                    <OptimizeButton />
                </div>
                <CompetitionStacking competitionType={Const.COMPETITION_STACKING_TYPE_FIGHT} />
                <PlayerGroupingsSwitch>
                    <PlayerCombinationStacking />
                </PlayerGroupingsSwitch>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;
    const {filters: playersFilter} = state.playersData;

    return {
        sportConfig,
        playersFilter,
    };
}

let PlayersDashboard = connect(mapStatesToProps)(PlayersDashboardComponent);

export {PlayersDashboard};
